/**
 * Etiquetas de la pantalla de Novedades: tipos de cambio y perfiles afectados.
 * Espejo de las claves que usa constants/novedades.js.
 */
export const TIPOS = {
  nuevo: { label: "Nuevo", color: "success", icon: "plus-circle" },
  mejora: { label: "Mejora", color: "info", icon: "trending-up" },
  correccion: { label: "Corrección", color: "warning", icon: "tool" },
};

/**
 * Un `tipo` mal escrito en las constantes no debe tumbar la pantalla: se
 * pinta en gris con la clave cruda para que se note al revisarla.
 */
export const etiquetaTipo = (tipo) => {
  return (
    TIPOS[tipo] ?? { label: tipo ?? "-", color: "secondary", icon: "circle" }
  );
};

/**
 * Color por perfil. Las llaves son las mismas de PROFILES
 * (components/VerticalLayout/SidebarContent.js) mas "Analista", que existe en
 * el backend pero falta en esa constante.
 */
export const PERFIL_COLOR = {
  SuperAdmin: "dark",
  Reseller: "primary",
  Administrador: "info",
  Concesionario: "dark",
  Checador: "secondary",
  Analista: "secondary",
  Operador: "success",
  Contabilidad: "secondary",
  Depositos: "secondary",
  "Venta combustible": "secondary",
  Servicios: "secondary",
};

/** Mismo criterio de fallback que etiquetaTipo. */
export const etiquetaPerfil = (nombre) => {
  return { label: nombre ?? "-", color: PERFIL_COLOR[nombre] ?? "secondary" };
};
